import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

// React Router does not reset scroll position when the route changes — the browser keeps
// whatever offset you were at. Navigating from the bottom of a long page (the CTAs at the
// foot of /about, say) therefore drops you into the middle of the next one.
//
// Renders nothing; mounted once inside <Router> in App.js so it covers every route.
//
// React Router 7 ships <ScrollRestoration /> for this, but only for data routers created
// with createBrowserRouter(). This app uses <BrowserRouter>, so it isn't available to us.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    // Back/forward should return the user to where they left off, which is what the browser
    // already does on its own. Forcing the top here would break that.
    if (navigationType === 'POP') return;

    // An in-page anchor (/pricing#service) is a request for a specific position, not the top.
    if (hash) return;

    // 'instant' rather than the default 'auto': if a stylesheet ever sets
    // scroll-behavior:smooth on the root, 'auto' would animate a long scroll back up on
    // every navigation. Falls back to the two-arg form on older Safari/Firefox, which
    // ignore the options object.
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    } catch {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash, navigationType]);

  return null;
}
